import { useTranslation } from 'react-i18next';

export default function LangSelector() {
    const { i18n } = useTranslation('', { useSuspense: false });

    return (
        <div className="absolute bottom-4 z-10 left-4 mt-4 mr-4 bg-[#000]/50 backdrop-blur-lg rounded-xl text-white p-4 flex flex-row gap-4 outline-2 outline-offset-2 outline-indigo-500">
            <div onClick={() => {i18n.changeLanguage("fi")}}><img src="/fin.svg" className="h-10" /></div>
            <div onClick={() => {i18n.changeLanguage("en")}}><img src="/usa.svg" className="h-10" /></div>
        </div>
    )
}